import React, { useEffect, useState } from "react";
import {
    Box, Grid, Typography, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, Divider
} from "@mui/material";
import axios from "axios";
import io from "socket.io-client";
import CircularSpinner from "../../../../Common/Spinners/CircularSpinner";
import SearchBar from "../../../../Common/UtilityCommon/SearchBar";
import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";

const headerCellStyle = {
    fontWeight: "bold",
    backgroundColor: "#3f51b5",
    color: "white",
    padding: "8px",
    textAlign: "center",
    "&:hover": {
        backgroundColor: "#303f9f",
        cursor: "pointer",
    },
};

const LiveAllTenders = () => {
    const apikey = process.env.REACT_APP_API;
    const socketURL = process.env.REACT_APP_API_URL;
    const company_code = sessionStorage.getItem("Company_Code");
    const year_code = sessionStorage.getItem("Year_Code");

    const [tenders, setTenders] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);

    // Fetch Tenders Data
    const fetchTenders = async () => {
        try {
            // setLoading(true);
            const res = await axios.get(
                `${apikey}/get_allTenders?Company_Code=${company_code}&Year_Code=${year_code}`
            );
            if (res.data.get_allTenders) {
                setTenders(res.data.get_allTenders);
                setFiltered(res.data.get_allTenders);
            }
        } catch (err) {
            console.error("Error fetching tenders:", err);
        }
        // finally {
        //     setLoading(false); 
        // }
    };

    useEffect(() => {
        const socket = io(`${socketURL}`, { transports: ["websocket"] });
        socket.on("connect", () => console.log("Socket connected:", socket.id));
        socket.on("get_allTenders", (data) => console.log("Connected to server:", data));
        socket.on("tender_added", fetchTenders);
        socket.on("tender_updated", fetchTenders);
        socket.on("tender_deleted", fetchTenders);
        fetchTenders();
        return () => socket.disconnect();
    }, []);

    useEffect(() => {
        const search = searchTerm.toLowerCase();
        const filteredData = tenders.filter((item) =>
            Object.values(item).some((val) =>
                String(val).toLowerCase().includes(search)
            ));
        setFiltered(filteredData);
    }, [searchTerm, tenders]);

    const handleSearchTermChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const groupByTenderDate = (data) => {
        const grouped = {};
        data.forEach(item => {
            if (!grouped[item.Tender_Date]) {
                grouped[item.Tender_Date] = [];
            }
            grouped[item.Tender_Date].push(item);
        });
        return grouped;
    };

    const calculateTotalQuantity = (group) => {
        return group.reduce((total, item) => total + parseFloat(item.Quantal || 0), 0);
    };

    const calculateResaleDifference = (item) => {
        const purchaseRate = item.Purc_Rate === 0 ? 0 : parseFloat(item.Purc_Rate || 0);
        const millRate = parseFloat(item.Mill_Rate || 0);
        const Quantal = parseFloat(item.Quantal || 0);
        return purchaseRate === 0 ? 0 : (millRate - purchaseRate) * Quantal;
    };

    const calculateTotalResaleDifference = (group) => {
        return group.reduce((total, item) => total + calculateResaleDifference(item), 0);
    };

    return (
        <Box style={{ marginTop: '-100px' }}>
            <Grid spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                <Grid item xs={12} sm={6}>
                    <SearchBar value={searchTerm} onChange={handleSearchTermChange} />
                </Grid>
            </Grid>

            <Paper elevation={3} sx={{ overflow: "auto", maxHeight: "90vh" }}>
                <TableContainer>
                    {/* {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="300px">
                            <CircularSpinner />
                        </Box>
                    ) : ( */}
                    <div style={{ maxHeight: '750px', overflow: 'auto' }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ whiteSpace: "nowrap" }} sx={headerCellStyle}><strong>Tender No</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Tender Date</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Lifting date</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Payment To</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Mill Name</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Grade</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Season</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Quantity</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Packing</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Bags</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Mill Rate</strong></TableCell>
                                    <TableCell style={{ whiteSpace: "nowrap" }} sx={headerCellStyle}><strong>Purchase Rate</strong></TableCell>
                                    <TableCell sx={headerCellStyle}><strong>Resale Diff.</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filtered.length > 0 ? (
                                    Object.entries(groupByTenderDate(filtered)).map(([date, group], groupIndex) => (
                                        <React.Fragment key={date}>
                                            {group.map((item, index) => (
                                                <TableRow key={`${groupIndex}-${index}`} hover>
                                                    <TableCell>{item.Tender_No}</TableCell>
                                                    <TableCell>{item.Tender_Date}</TableCell>
                                                    <TableCell>{item.Lifting_Date}</TableCell>
                                                    <TableCell>{item.DO}</TableCell>
                                                    <TableCell>{item.Mill_Name}</TableCell>
                                                    <TableCell align="center">{item.Grade}</TableCell>
                                                    <TableCell>{item.season}</TableCell>
                                                    <TableCell align="right">{item.Quantal}</TableCell>
                                                    <TableCell align="right">{item.Packing}</TableCell>
                                                    <TableCell align="right">{item.Bags}</TableCell>
                                                    <TableCell align="right">{item.Mill_Rate}</TableCell>
                                                    <TableCell align="right">{item.Purc_Rate}</TableCell>
                                                    <TableCell align="right" style={{
                                                        color: calculateResaleDifference(item) >= 0 ? 'green' : 'red',
                                                        fontWeight: 'bold'
                                                    }}>{formatReadableAmount(calculateResaleDifference(item).toFixed(2))}</TableCell>
                                                </TableRow>
                                            ))}

                                            <TableRow sx={{ backgroundColor: '#edf0dfff' }}>
                                                <TableCell colSpan={7} align="right">
                                                    <strong>Total for {date}:</strong>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <strong>{formatReadableAmount(calculateTotalQuantity(group).toFixed(2))}</strong>
                                                </TableCell>
                                                <TableCell colSpan={4}></TableCell>
                                                <TableCell align="right" style={{
                                                    color: calculateTotalResaleDifference(group) >= 0 ? 'green' : 'red',
                                                    fontWeight: 'bold',
                                                    whiteSpace: 'nowrap',
                                                }}

                                                >
                                                    Resale Diff : <strong>{formatReadableAmount(calculateTotalResaleDifference(group).toFixed(2))}</strong>
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell colSpan={12} sx={{ height: '10px', borderBottom: 'none' }} />
                                            </TableRow>

                                            <TableRow>
                                                <TableCell colSpan={12} sx={{ padding: 0, border: 0 }}>
                                                    <Divider
                                                        sx={{
                                                            borderBottomWidth: 2,
                                                            backgroundColor: '#3f51b5',
                                                            height: '2px',
                                                            transition: 'background-color 0.3s ease',
                                                            '&:hover': {
                                                                backgroundColor: '#0a1deeff',
                                                            },
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell colSpan={12} sx={{ height: '10px', borderBottom: 'none' }} />
                                            </TableRow>
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={12} align="center">Data Not Found!</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                    {/* )} */}
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default LiveAllTenders;
